module.exports = __webpack_public_path__ + "img/icon5.fbd1dbf6.png";